import React, { createContext, useState, useEffect } from 'react';
import Cookies from 'js-cookie';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);

    useEffect(() => {
        const storedUser = Cookies.get('user'); // Recupera el usuario autenticado de las cookies
        if (storedUser) {
            setUser(JSON.parse(storedUser));
        }
    }, []);

    const login = (userData) => {
        setUser(userData); // Guarda el usuario en el estado
        Cookies.set('user', JSON.stringify(userData)); // Guarda el usuario en las cookies
    };

    const logout = () => {
        setUser(null); // Limpia el estado
        Cookies.remove('user'); // Elimina el usuario de las cookies
    };

    return (
        <AuthContext.Provider value={{ user, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
};
